import { Button } from '@mui/material';
import React from 'react';
import Icon from './Icon';

function IconButton({
  name,
  sx,
  ...props
}) {
  return (
    <Button
      startIcon={<Icon name={name} />}
      sx={{
        '.MuiButton-startIcon': {
          marginRight: 0,
          marginLeft: 0,
        },
        '&.MuiButton-sizeMedium': {
          p: '12px',
        },
        '&.MuiButton-sizeSmall': {
          p: '8px',
        },
        minWidth: 'unset',
        ...sx,
      }}
      size="small"
      {...props}
    />
  );
}

export default IconButton;
